import { combineReducers } from "redux";
import { invoiceReducer } from "./invoiceReducer";
import { paymentReducer } from "./paymentReducer";
import { recaptchaReducer } from "./recaptchaReducer";
var reducers = combineReducers({
    invoice: invoiceReducer,
    payments: paymentReducer,
    recaptcha: recaptchaReducer,
});
export default reducers;
